import React from "react";

const LeftLinks = ({ updateShowFilter }) => {
  return (
    <div className="job-links-column">
      <button className="filter-close" onClick={updateShowFilter}>
        <svg
          className="icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <title>Close Filter</title>
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
      <div class="h4">By Type</div>
      <ul>
        <li>
          <a
            href="/pharmacy-jobs/contract-travel-pharmacy-jobs/"
            title="Contract/Travel Pharmacy Jobs"
          >
            Contract/Travel
          </a>
        </li>
        <li>
          <a
            href="/pharmacy-jobs/part-time-pharmacy-jobs/"
            title="Part-Time Pharmacy Jobs"
          >
            Part-Time
          </a>
        </li>
        <li>
          <a
            href="/pharmacy-jobs/per-diem-pharmacy-jobs/"
            title="Per Diem Pharmacy Jobs"
          >
            Per Diem
          </a>
        </li>
        <li>
          <a
            href="/pharmacy-jobs/permanent-direct-hire-pharmacy-jobs/"
            title="Direct Hire/Permanent Pharmacy Jobs"
          >
            Direct Hire/Permanent
          </a>
        </li>
      </ul>
      <div class="h4">By Setting</div>
      <ul>
        <li>
          <a
            href="/pharmacy-jobs/hospital-inpatient-pharmacy-jobs/"
            title="Hospital Inpatient Pharmacy Jobs"
          >
            Hospital Inpatient
          </a>
        </li>
        <li>
          <a
            href="/pharmacy-jobs/hospital-outpatient-pharmacy-jobs/"
            title="Hospital Outpatient Pharmacy Jobs"
          >
            Hospital Outpatient
          </a>
        </li>
        <li>
          <a
            href="/pharmacy-jobs/retail-pharmacy-jobs/"
            title="Retail Pharmacy Jobs"
          >
            Retail
          </a>
        </li>
        <li>
          <a
            href="/pharmacy-jobs/home-infusion-pharmacy-jobs/"
            title="Home Infusion Pharmacy Jobs"
          >
            Home Infusion
          </a>
        </li>
        <li>
          <a
            href="/pharmacy-jobs/remote-pharmacy-technician-jobs/"
            title="Remote Pharmacy Jobs"
          >
            Remote
          </a>
        </li>
        <li>
          <a
            href="/pharmacy-jobs/long-term-care-pharmacy-jobs/"
            title="Long-term Care Pharmacy Jobs"
          >
            Long-term Care
          </a>
        </li>
        <li>
          <a
            href="/pharmacy-jobs/mail-order-pharmacy-jobs/"
            title="Mail-Order Pharmacy Jobs"
          >
            Mail-Order
          </a>
        </li>
        <li>
          <a
            href="/pharmacy-jobs/government-federal-pharmacy-jobs/"
            title="Government & Federal Pharmacy Jobs"
          >
            Government & Federal
          </a>
        </li>
        <li>
          <a
            href="/pharmacy-jobs/veterinary-pharmacy-jobs/"
            title="Veterinary Pharmacy Jobs"
          >
            Veterinary
          </a>
        </li>
        <li>
          <a
            href="/pharmacy-jobs/compounding-pharmacy-jobs/"
            title="Compounding Pharmacy Jobs"
          >
            Compounding
          </a>
        </li>
      </ul>
    </div>
  );
};

export default LeftLinks;